var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._b({attrs:{"placeholder":"数字","type":"number"},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=_vm._n($$v)},expression:"inputVal"}},'el-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }